<script setup>
// Logo.vue - Using external SVG assets for the logo
import { computed } from 'vue';

const props = defineProps({
  variant: {
    type: String,
    default: 'default', // 'default' or 'white'
  },
  size: {
    type: String,
    default: 'md' // 'sm', 'md', 'lg'
  },
  collapsed: {
    type: Boolean,
    default: false
  }
});

// Size classes that control the height of the logo
const sizeClasses = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-10'
};

// Apply inverted colors for white variant using a class
const logoClass = computed(() => {
  return props.variant === 'white' ? 'logo-white' : 'logo-default';
});
</script>

<template>
  <div class="logo-container" :class="[sizeClasses[size], logoClass]">
    <!-- Collapsed state: show favicon -->
    <img 
      v-if="collapsed"
      src="/favicon.ico" 
      alt="Idou.ai" 
      class="logo-favicon" 
    />
    
    <!-- Expanded state: show full logo -->
    <template v-else>
      <!-- Desktop logo (hidden on mobile) -->
      <img 
        src="/images/logo_final_cropped.png" 
        alt="Idou.ai" 
        class="logo-img hidden sm:block" 
      />
      
      <!-- Mobile logo (shown only on mobile) -->
      <img 
        src="/images/logo_final_cropped.png" 
        alt="Idou.ai" 
        class="logo-img block sm:hidden" 
      />
    </template>
  </div>
</template>

<style scoped>
.logo-container {
  display: inline-flex;
  align-items: center;
}

.logo-img {
  height: 100%;
  width: auto;
}

/* White variant (for dark backgrounds) */
.logo-white {
  filter: brightness(0) invert(1); /* Makes the logo white */
}

/* Collapsed state: favicon styling */
.logo-favicon {
  height: 28px;
  width: 28px;
  border-radius: 4px;
}

/* Mobile sizing is driven by `size` prop; avoid overriding with min-sizes */
</style> 